import { render, staticRenderFns } from "./bj.vue?vue&type=template&id=92feb246&scoped=true&"
import script from "./bj.vue?vue&type=script&lang=js&"
export * from "./bj.vue?vue&type=script&lang=js&"
import style0 from "./bj.vue?vue&type=style&index=0&id=92feb246&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92feb246",
  null
  
)

export default component.exports